<div class="banner-stack" role="log">
  @for (n of items(); track n.id) {
    <div class="banner banner--{{ n.level }}">
      <span class="banner__message">{{ n.message }}</span>
      <button
        type="button"
        class="banner__dismiss"
        (click)="dismiss(n.id)"
        i18n="@@notifications.dismiss"
      >
        ×
      </button>
    </div>
  }
</div>
